import CorridorPageTemplate from "@/components/CorridorPageTemplate";

const MidwestFreight = () => (
  <CorridorPageTemplate
    seoTitle="Midwest Freight Services | Varstar Alliance"
    seoDesc="Freight shipping across the Midwest - Illinois, Michigan, Ohio, Indiana, Wisconsin, and Minnesota. FTL, LTL, reefer, and intermodal. Free quote."
    canonical="/corridors/midwest-freight"
    h1="Midwest Freight Shipping Services"
    subtitle="From the Great Lakes to the heartland - reliable freight across America's manufacturing and distribution hub."
    corridorName="Midwest"
    overview="The Midwest is the backbone of American manufacturing, agriculture, and distribution. With major logistics hubs in Chicago, Detroit, Columbus, Indianapolis, and Milwaukee, this region demands reliable, flexible freight solutions.

Varstar Alliance is headquartered in Detroit, placing us at the center of the Midwest's most critical freight corridors. We serve manufacturers, food producers, retailers, and distributors across Illinois, Michigan, Ohio, Indiana, Wisconsin, Minnesota, and beyond.

Our combination of owned assets and a 40,000+ carrier brokerage network means guaranteed capacity even during peak seasons, harvest rushes, and automotive production surges."
    keyLanes={[
      { origin: "Detroit, MI", dest: "Chicago, IL", transit: "5–6 hours" },
      { origin: "Chicago, IL", dest: "Columbus, OH", transit: "5–6 hours" },
      { origin: "Detroit, MI", dest: "Indianapolis, IN", transit: "4–5 hours" },
      { origin: "Milwaukee, WI", dest: "Detroit, MI", transit: "5–6 hours" },
      { origin: "Minneapolis, MN", dest: "Chicago, IL", transit: "6–7 hours" },
      { origin: "Grand Rapids, MI", dest: "Columbus, OH", transit: "4–5 hours" },
      { origin: "Chicago, IL", dest: "St. Louis, MO", transit: "4–5 hours" },
      { origin: "Detroit, MI", dest: "Cleveland, OH", transit: "3–4 hours" },
    ]}
    advantages={[
      "Detroit-headquartered - embedded in the Midwest logistics network",
      "Asset fleet + 40,000 carrier brokerage for guaranteed capacity",
      "Automotive JIT expertise for Midwest manufacturing corridors",
      "Reefer-ready for agriculture and food distribution",
      "Intermodal options via Chicago - the nation's rail hub",
      "Cross-border capabilities for Midwest-to-Canada freight",
    ]}
    services={[
      "Full Truckload (FTL) - dry van, flatbed, step deck",
      "Less-Than-Truckload (LTL) with regional consolidation",
      "Temperature-controlled (reefer) for food & agriculture",
      "Intermodal via Chicago rail hub",
      "Dedicated fleet for high-volume shippers",
      "Cross-border - Midwest to Ontario and Quebec",
    ]}
    stats={[
      { val: "6", label: "States Covered" },
      { val: "40K+", label: "Carriers" },
      { val: "98%", label: "On-Time Rate" },
      { val: "24/7", label: "Dispatch" },
    ]}
  />
);

export default MidwestFreight;
